$(document).ready(function(){

	// -- Hamburger --
	$('.hamburger').on('click', function(){
		$('body').toggleClass('mainMenu--open');
		$(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
		$(this).attr('aria-haspopup', $(this).attr('aria-haspopup') === 'true' ? 'false' : 'true');
		$(this).toggleClass('is-active');
	});

	// // -- Close mobile menu when click
	// $('.main__nav li a:not(.dropdown-toggle)').on('click', function(){
	// 	$('body').removeClass('mobileMenu--open');
	// 	$('.hamburger').removeClass('is-active');
	// });

	// -- Dropdown --
	$(document).on('click', '.dropdown-toggle', function(e){
		e.preventDefault();		
		if (!$(this).parent('.dropdown').hasClass('open')) {
			$('.dropdown').removeClass('open');
			$(this).parent('.dropdown').toggleClass('open');
		} else {
			$('.dropdown').removeClass('open');
		}
	});

	// -- Close dropdown when click outside --
	$(document).on('mouseup', function(e) {
	  var container = $('.dropdown');
	  if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.dropdown').removeClass('open');
	  }
	});

	// -- Close dropdown on mouseleave --
	var closeDropdownMenu; // global
	$('.main__nav').on('mouseleave', '.dropdown-menu', function(){
		closeDropdownMenu = setTimeout(function(){
			$('.dropdown').removeClass('open');
		},3000);
	});

	// // -- Clear timeout to prevent close dropdown on mouseenter --
	// $('.main__nav').on('mouseenter', '.dropdown-menu', function(){
	// 	clearTimeout(closeDropdownMenu);
	// });

});



$(document).on('scroll resize orientationchange', function(){
	// -- Header fixed --
	var scrollTop = $(this).scrollTop();
	var header = $('.header').outerHeight();
	if (scrollTop > header) {
		$('body').addClass('header--fixed');
	} else {
		$('body').removeClass('header--fixed');
	}
});